export default __webpack_public_path__ + "1435119e105fd0a79eec883f914ff92f.png";